module.exports = __webpack_public_path__ + "img/treetop.67961a8a.svg";